<template>
  <!--
    Faixa de contexto: diz sobre QUEM a conversa esta acontecendo.

    Ela reflete o estado que vai junto de cada mensagem para o servidor — nao e
    uma leitura da conversa. Se fosse inferida do texto, mentiria assim que o
    historico estourasse a janela do modelo.
  -->
  <div
    v-if="customer || operation"
    class="ctx"
    data-test="clara-context-bar"
  >
    <component
      :is="operation ? 'PhReceipt' : 'PhUser'"
      :size="13"
      class="ctx__icon"
    />

    <button
      type="button"
      class="ctx__name"
      data-test="clara-context-change"
      :title="tooltip"
      @click="$emit('change')"
    >
      <span class="ctx__label">Conversando sobre</span>
      <span class="ctx__value">{{ description }}</span>
    </button>

    <v-btn
      icon
      x-small
      class="ctx__clear"
      aria-label="Limpar o contexto da conversa"
      data-test="clara-context-clear"
      @click="$emit('clear')"
    >
      <PhX :size="12" />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ClaraContextBar',

  props: {
    customer: {
      type: Object,
      default: null
    },

    operation: {
      type: Object,
      default: null
    }
  },

  computed: {
    /* Com operacao, ela vem primeiro e o cliente fica como qualificador: e o
       assunto mais especifico, e e o que o operador escolheu na tabela. */
    description() {
      if (this.operation && this.customer) {
        return `Operação #${this.operation.id} · ${this.customer.name}`;
      }

      if (this.operation) return `Operação #${this.operation.id}`;

      return this.customer?.name || '';
    },

    tooltip() {
      return `Conversando sobre ${this.description}. Clique para trocar.`;
    }
  }
};
</script>

<style scoped>
.ctx {
  display: flex;
  align-items: center;
  gap: var(--tc-space-2);
  padding: var(--tc-space-2) var(--tc-space-3);
  background: var(--clara-tint);
  border-bottom: 1px solid var(--tc-line);
  color: var(--clara-text);
  flex-shrink: 0;
}

.ctx__icon {
  flex-shrink: 0;
}

/* O nome ocupa a sobra e trunca: nome de PJ e longo e nao pode empurrar o "x"
   para fora do painel, que ja e estreito. */
.ctx__name {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: var(--tc-space-2);
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

.ctx__label {
  font-size: 0.7rem;
  opacity: 0.75;
  flex-shrink: 0;
}

.ctx__value {
  font-size: 0.78rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ctx__name:hover .ctx__value {
  text-decoration: underline;
}

.ctx__name:focus-visible {
  outline: 2px solid var(--clara-text);
  outline-offset: 2px;
  border-radius: 2px;
}

.ctx__clear {
  flex-shrink: 0;
  color: var(--clara-text) !important;
}
</style>
